import AppsSharpIcon from "@mui/icons-material/AppsSharp";
import ViewListIcon from "@mui/icons-material/ViewList";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { Dispatch, FC } from "react";
import { logCustomEvent } from "../../datadog";

export type SearchResultsLayout = "grid" | "table";

export interface SearchResultsLayoutInputProps {
  value: SearchResultsLayout;
  onChange: Dispatch<SearchResultsLayout>;
}

export const SearchResultsLayoutInput: FC<SearchResultsLayoutInputProps> = ({
  value,
  onChange,
}) => {
  const handleChange = (next: SearchResultsLayout) => {
    logCustomEvent("search-results-view-change", { view: next });
    onChange(next);
  };
  return (
    <ToggleButtonGroup
      size={"small"}
      value={value}
      exclusive
      onChange={(_, value) => value && handleChange(value)}
    >
      <ToggleButton value="table">
        <ViewListIcon />
      </ToggleButton>
      <ToggleButton value="grid">
        <AppsSharpIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
